// Lets the Android/PWA hardware/gesture back button close the topmost open
// dialog or mobile detail view instead of routing away from the app.
// Each open layer pushes one history entry; popstate pops the topmost
// registered handler (LIFO), so stacked dialogs close one at a time.

type Handler = () => void;

const stack: { id: number; handler: Handler }[] = [];
let nextId = 1;
let suppressCount = 0;
let listenerAttached = false;

function ensureListener() {
  if (listenerAttached) return;
  listenerAttached = true;
  window.addEventListener("popstate", () => {
    if (suppressCount > 0) {
      suppressCount--;
      return;
    }
    const top = stack.pop();
    if (top) top.handler();
  });
}

export function pushBackGuard(handler: Handler): number {
  ensureListener();
  const id = nextId++;
  window.history.pushState({ __backGuardId: id }, "");
  stack.push({ id, handler });
  return id;
}

export function popBackGuard(id: number) {
  const idx = stack.findIndex(x => x.id === id);
  if (idx === -1) return; // already consumed by a real back press
  stack.splice(idx, 1);
  suppressCount++;
  window.history.back();
}
